"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewCaseDataSerializer = exports.ExternalPartnerSerializer = exports.ChargeSerializer = exports.ChargingStationSerializer = exports.BankAccountSerializer = exports.PersonSerializer = exports.QuestionnaireSerializer = exports.EmobilityDocumentsSerializer = exports.EmobilityDocumentSerializer = exports.CorrespondenceSerializer = exports.PhoneSerializer = exports.OrganisationSerializer = exports.InstallationAddressSerializer = exports.CorrespondanceAddressSerializer = exports.AddressSerializer = void 0;
const tslib_1 = require("tslib");
const DutchBoolean_1 = require("./enums/DutchBoolean");
const CaseStates_1 = require("./enums/CaseStates");
const mount_type_1 = tslib_1.__importDefault(require("./enums/mount-type"));
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class AddressSerializer extends base_models_1.Serializable {
}
exports.AddressSerializer = AddressSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'care of full name', example: 'dhr Piet van Beek' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], AddressSerializer.prototype, "careofFullName", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'street name', example: 'Hoofdstraat' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], AddressSerializer.prototype, "street", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'house number', example: '4' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], AddressSerializer.prototype, "houseNumber", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'extension to house number', example: 'bis' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], AddressSerializer.prototype, "houseNumberExtension", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'postal/zip code', example: '1234 AB' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], AddressSerializer.prototype, "postCode", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'postal box', example: 'Postbus 123' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], AddressSerializer.prototype, "POBox", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'city', example: 'Rotterdam' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], AddressSerializer.prototype, "city", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'country', example: 'The Netherlands' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], AddressSerializer.prototype, "country", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'department', example: '' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], AddressSerializer.prototype, "department", void 0);
class CorrespondanceAddressSerializer extends AddressSerializer {
}
exports.CorrespondanceAddressSerializer = CorrespondanceAddressSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'country code', example: 'NL' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], CorrespondanceAddressSerializer.prototype, "countryCode", void 0);
class InstallationAddressSerializer extends AddressSerializer {
}
exports.InstallationAddressSerializer = InstallationAddressSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'start date', example: '2023-03-28' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], InstallationAddressSerializer.prototype, "startDate", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'end date', example: '2024-03-29' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], InstallationAddressSerializer.prototype, "endDate", void 0);
class OrganisationSerializer extends base_models_1.Serializable {
}
exports.OrganisationSerializer = OrganisationSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'organisation name', example: 'Essent BV' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], OrganisationSerializer.prototype, "organisationName", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'chamber of commerce number', example: '9305 6589' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], OrganisationSerializer.prototype, "chamberofCommerceNumber", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'Number for VAT', example: 'NL000099998B57' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], OrganisationSerializer.prototype, "vatNumber", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'legal entity', example: 'BV' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], OrganisationSerializer.prototype, "legalEntity", void 0);
class PhoneSerializer extends base_models_1.Serializable {
}
exports.PhoneSerializer = PhoneSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'phone number', example: '0612345789' }),
    (0, class_validator_1.IsPhoneNumber)('NL'),
    tslib_1.__metadata("design:type", String)
], PhoneSerializer.prototype, "phoneNumber", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'is this the primary phone number', example: true }),
    (0, class_validator_1.IsBoolean)(),
    tslib_1.__metadata("design:type", Boolean)
], PhoneSerializer.prototype, "primary", void 0);
class CorrespondenceSerializer extends base_models_1.Serializable {
}
exports.CorrespondenceSerializer = CorrespondenceSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'address', example: {} }),
    (0, class_transformer_1.Type)(() => CorrespondanceAddressSerializer),
    tslib_1.__metadata("design:type", CorrespondanceAddressSerializer)
], CorrespondenceSerializer.prototype, "address", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'phone data', example: {} }),
    (0, class_transformer_1.Type)(() => PhoneSerializer),
    tslib_1.__metadata("design:type", PhoneSerializer)
], CorrespondenceSerializer.prototype, "phone", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'email address', example: 'firstname.lastname@customer.nl' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], CorrespondenceSerializer.prototype, "email", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'preferred communication channel', example: 'email' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], CorrespondenceSerializer.prototype, "preferredChannel", void 0);
class EmobilityDocumentSerializer extends base_models_1.Serializable {
}
exports.EmobilityDocumentSerializer = EmobilityDocumentSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'document id', example: '1234' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], EmobilityDocumentSerializer.prototype, "id", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'filename', example: 'picture.jpg' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], EmobilityDocumentSerializer.prototype, "fileName", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'download url', example: 'https://s3.amazonaws.nl/emobility/picture.jpg' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], EmobilityDocumentSerializer.prototype, "url", void 0);
class EmobilityDocumentsSerializer extends base_models_1.Serializable {
}
exports.EmobilityDocumentsSerializer = EmobilityDocumentsSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'smart meter image', example: {} }),
    (0, class_transformer_1.Type)(() => EmobilityDocumentSerializer),
    tslib_1.__metadata("design:type", EmobilityDocumentSerializer)
], EmobilityDocumentsSerializer.prototype, "smartMeter", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'group box image', example: {} }),
    (0, class_transformer_1.Type)(() => EmobilityDocumentSerializer),
    tslib_1.__metadata("design:type", EmobilityDocumentSerializer)
], EmobilityDocumentsSerializer.prototype, "groupbox", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'fuse box image', example: {} }),
    (0, class_transformer_1.Type)(() => EmobilityDocumentSerializer),
    tslib_1.__metadata("design:type", EmobilityDocumentSerializer)
], EmobilityDocumentsSerializer.prototype, "fusebox", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'crawl space image', example: {} }),
    (0, class_transformer_1.Type)(() => EmobilityDocumentSerializer),
    tslib_1.__metadata("design:type", EmobilityDocumentSerializer)
], EmobilityDocumentsSerializer.prototype, "crawlSpace", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'installation site image', example: {} }),
    (0, class_transformer_1.Type)(() => EmobilityDocumentSerializer),
    tslib_1.__metadata("design:type", EmobilityDocumentSerializer)
], EmobilityDocumentsSerializer.prototype, "installationSite", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'digging ground type image 1', example: {} }),
    (0, class_transformer_1.Type)(() => EmobilityDocumentSerializer),
    tslib_1.__metadata("design:type", EmobilityDocumentSerializer)
], EmobilityDocumentsSerializer.prototype, "digginggroundtype", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'digging ground type image 2', example: {} }),
    (0, class_transformer_1.Type)(() => EmobilityDocumentSerializer),
    tslib_1.__metadata("design:type", EmobilityDocumentSerializer)
], EmobilityDocumentsSerializer.prototype, "digginggroundtype2", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'quotation document (PDF)', example: {} }),
    (0, class_transformer_1.Type)(() => EmobilityDocumentSerializer),
    tslib_1.__metadata("design:type", EmobilityDocumentSerializer)
], EmobilityDocumentsSerializer.prototype, "quotationDocument", void 0);
class QuestionnaireSerializer extends base_models_1.Serializable {
}
exports.QuestionnaireSerializer = QuestionnaireSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'is a smart meter installed', example: DutchBoolean_1.DutchBoolean.True }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "smartMeterInstalled", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        description: 'distance between electric closet and installation site in meters (integer)',
        example: '6',
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "metersfromClosettoSite", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'is fusebox connected to wall', example: DutchBoolean_1.DutchBoolean.False }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "fuseboxConnectedtoWall", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        description: 'will the charging station be mounted on wall or pole',
        example: mount_type_1.default.Pole,
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "wallorPoleMounted", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'is the crawl space dry, roomy and safe', example: DutchBoolean_1.DutchBoolean.True }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "crawlSpaceWorkable", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'does the installation crew need to dig', example: DutchBoolean_1.DutchBoolean.False }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "diggingRequired", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'estimated meters to dig (integer)', example: '0' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "estimatedDiggingMeters", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'digging surface type', example: 'tough' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "diggingSurfaceType", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'fixed or modular cable', example: DutchBoolean_1.DutchBoolean.False }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "fixedorModularCable", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'color of the charging station', example: 'antraciet' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "colorChargingStation", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'socket charging station', example: '' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "socketChargingStations", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'data subscription', example: DutchBoolean_1.DutchBoolean.False }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "dataSubscription", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'service subscription', example: DutchBoolean_1.DutchBoolean.True }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "serviceSubscription", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'electricity mains value', example: 'value' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "electricityMainsValue", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'load balancing', example: DutchBoolean_1.DutchBoolean.True }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "loadBalancing", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'replace fuse box', example: DutchBoolean_1.DutchBoolean.False }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "replaceFusebox", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'group box upgrade', example: DutchBoolean_1.DutchBoolean.False }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "groupboxUpgrade", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'documents and pictures', example: {} }),
    (0, class_transformer_1.Type)(() => EmobilityDocumentsSerializer),
    tslib_1.__metadata("design:type", EmobilityDocumentsSerializer)
], QuestionnaireSerializer.prototype, "document", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'installation notes', example: 'watch out for the dog' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "installationNotes", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'ground work notes', example: 'careful for the flowers' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], QuestionnaireSerializer.prototype, "groundworkNotes", void 0);
class PersonSerializer extends base_models_1.Serializable {
}
exports.PersonSerializer = PersonSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'date of birth', example: '1990-12-31' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PersonSerializer.prototype, "dateofBirth", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'gender', example: 'male' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PersonSerializer.prototype, "gender", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'last name', example: 'Beek' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PersonSerializer.prototype, "lastName", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'first name', example: 'Piet' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PersonSerializer.prototype, "firstName", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'prefix to a last name', example: 'van' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PersonSerializer.prototype, "prefix", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'initials', example: 'P.A.' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PersonSerializer.prototype, "initials", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'title/salutation', example: 'dhr' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PersonSerializer.prototype, "title", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'telephone number', example: '06-12345789' }),
    (0, class_validator_1.IsPhoneNumber)(),
    tslib_1.__metadata("design:type", String)
], PersonSerializer.prototype, "telephoneNumber", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'email address', example: 'piet.van.beek@customer.nl' }),
    (0, class_validator_1.IsEmail)(),
    tslib_1.__metadata("design:type", String)
], PersonSerializer.prototype, "emailAddress", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'can Essent call the customer back', example: 'Ja' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PersonSerializer.prototype, "callbackConsent", void 0);
class BankAccountSerializer extends base_models_1.Serializable {
}
exports.BankAccountSerializer = BankAccountSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'bank account number (iban)', example: 'NL18RABO0123459876' }),
    (0, class_validator_1.IsIBAN)(),
    tslib_1.__metadata("design:type", String)
], BankAccountSerializer.prototype, "bankAccountNumber", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'account holder name', example: 'P. van Beek ROTTERDAM' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], BankAccountSerializer.prototype, "accountHolderName", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'direct debit approval', example: 'confirmed 2023-04-14' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], BankAccountSerializer.prototype, "directDebitApproval", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'consented to terms and conditions', example: 'consented 2023-04-13' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], BankAccountSerializer.prototype, "consentedtoTandC", void 0);
class ChargingStationSerializer extends base_models_1.Serializable {
}
exports.ChargingStationSerializer = ChargingStationSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'identifier', example: 'NL-ESSE-01234566' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargingStationSerializer.prototype, "identifier", void 0);
class ChargeSerializer extends base_models_1.Serializable {
}
exports.ChargeSerializer = ChargeSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'charging station name', example: 'name' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargeSerializer.prototype, "chargingStationName", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'charge card', example: 'card' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargeSerializer.prototype, "chargeCard", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'identifier of the charging station', example: 'NL-ESSE-0001234' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargeSerializer.prototype, "identifyChargingStation", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'identifier of the charge card', example: 'NL-ESSE-01234-A' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargeSerializer.prototype, "identifyChargeCard", void 0);
class ExternalPartnerSerializer extends base_models_1.Serializable {
}
exports.ExternalPartnerSerializer = ExternalPartnerSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'employee', example: 'R12345' }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], ExternalPartnerSerializer.prototype, "employee", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'cancel reason', example: 'Not interested' }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], ExternalPartnerSerializer.prototype, "cancelReason", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'sales partner store', example: 'Utrecht' }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], ExternalPartnerSerializer.prototype, "salesPartnerStore", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'date entered', example: '2024-01-01T01:01:01.843Z' }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Date)
], ExternalPartnerSerializer.prototype, "dateEntered", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'product type', example: 'Charging Station' }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], ExternalPartnerSerializer.prototype, "productType", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'campaign', example: '200 Euro Korting' }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], ExternalPartnerSerializer.prototype, "campaign", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'service partner', example: 'Mediamarkt' }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], ExternalPartnerSerializer.prototype, "servicePartner", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'channel', example: 'MEDIAMKT' }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], ExternalPartnerSerializer.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'external partner name', example: 'Media Mrkt' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ExternalPartnerSerializer.prototype, "externalPartnerName", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'invoice group', example: 'Group' }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], ExternalPartnerSerializer.prototype, "invoiceGroup", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'lead segment', example: 'Lease' }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], ExternalPartnerSerializer.prototype, "leadSegment", void 0);
class ViewCaseDataSerializer extends base_models_1.Serializable {
}
exports.ViewCaseDataSerializer = ViewCaseDataSerializer;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'emobility ID (case ID)', example: '12345' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ViewCaseDataSerializer.prototype, "emobilityId", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'proposition id', example: 'particulier-laden' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ViewCaseDataSerializer.prototype, "propositionId", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'account id', example: '0123456789' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ViewCaseDataSerializer.prototype, "accountId", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'customer segment', example: 'Household' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ViewCaseDataSerializer.prototype, "customerSegment", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'installation address', example: {} }),
    (0, class_transformer_1.Type)(() => InstallationAddressSerializer),
    tslib_1.__metadata("design:type", InstallationAddressSerializer)
], ViewCaseDataSerializer.prototype, "installationAddress", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'case state', example: CaseStates_1.CaseStates.ProcessFinalized }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ViewCaseDataSerializer.prototype, "state", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'reimbursement account id', example: '0198765432' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ViewCaseDataSerializer.prototype, "reimbursementAccountId", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'questionnaire', example: {} }),
    (0, class_transformer_1.Type)(() => QuestionnaireSerializer),
    tslib_1.__metadata("design:type", QuestionnaireSerializer)
], ViewCaseDataSerializer.prototype, "questionnaire", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'bank account', example: {} }),
    (0, class_transformer_1.Type)(() => BankAccountSerializer),
    tslib_1.__metadata("design:type", BankAccountSerializer)
], ViewCaseDataSerializer.prototype, "bankAccount", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'order date', example: '2023-03-31' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ViewCaseDataSerializer.prototype, "orderDate", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'installation date', example: '2023-04-16' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ViewCaseDataSerializer.prototype, "installationDate", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        description: 'questionnaire link',
        example: 'https://mijn.essent.nl/emobility/schouwformulier',
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ViewCaseDataSerializer.prototype, "questionnaireLink", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'portal link', example: 'https://mijn.essent.nl' }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ViewCaseDataSerializer.prototype, "portalLink", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'charge', example: {} }),
    (0, class_transformer_1.Type)(() => ChargeSerializer),
    tslib_1.__metadata("design:type", ChargeSerializer)
], ViewCaseDataSerializer.prototype, "charge", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'brand', example: base_models_1.Brand.ESSENT }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ViewCaseDataSerializer.prototype, "brand", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'organisation', example: {} }),
    (0, class_transformer_1.Type)(() => OrganisationSerializer),
    tslib_1.__metadata("design:type", OrganisationSerializer)
], ViewCaseDataSerializer.prototype, "organisation", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'reimbursement applicable', example: 'false' }),
    (0, class_validator_1.IsBooleanString)(),
    tslib_1.__metadata("design:type", String)
], ViewCaseDataSerializer.prototype, "reimbursementApplicable", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'business order', example: false }),
    (0, class_validator_1.IsBoolean)(),
    tslib_1.__metadata("design:type", Boolean)
], ViewCaseDataSerializer.prototype, "businessOrder", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'determine whether customer is lease or not', example: false }),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", Boolean)
], ViewCaseDataSerializer.prototype, "isLeaseCustomer", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'person', example: {} }),
    (0, class_transformer_1.Type)(() => PersonSerializer),
    tslib_1.__metadata("design:type", PersonSerializer)
], ViewCaseDataSerializer.prototype, "person", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'external partner', example: {} }),
    (0, class_transformer_1.Type)(() => ExternalPartnerSerializer),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", ExternalPartnerSerializer)
], ViewCaseDataSerializer.prototype, "externalPartner", void 0);
